import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialProductsReportsFilterData,
  InitialProductsReportsFilterDataVariables
} from "./types/InitialProductsReportsFilterData";
import { ProductReport, ProductReportVariables } from "./types/ProductReport";

export const ProductReportListQuery = gql`
  ${pageInfoFragment}
  query ProductReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: ProductReportFilterInput!
  ) {
    productReport(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          product_name
          order_date
          store_order_code
          order_id
          signatory_email
          contract_id
          sku
          category_name
          brand_name
          quantity
          total_net_amount
          discount_amount
          discount
          total_gross_transaction
          discount_value
          voucher_code
          currency
          status
          completed_at
          price_amount
          total_gross_amount
          shipping_method_name
          carrier
          payment_method_type
          mall_name
          mall_code
          brand_name
          tenant_type
          length
          width
          height
          weight
          description
          available_for_purchase
          total_quantity
        }
      }
    }
  }
`;
export const useProductReportsListQuery = makeBossQuery<
  ProductReport,
  ProductReportVariables
>(ProductReportListQuery);

export const initialProductsReportsFilterDataQuery = gql`
  query InitialProductsReportsFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialProductsReportsFilterDataQuery = makeQuery<
  InitialProductsReportsFilterData,
  InitialProductsReportsFilterDataVariables
>(initialProductsReportsFilterDataQuery);
